/* eslint no-unused-expressions: 0 */

import React from 'react';
import PropTypes from 'prop-types';

import SEO from '../components/SEO';

import '../styles/main.scss'
import '../styles/header.scss'
import '../styles/footer.scss'
import '../styles/menu.scss'
import '../styles/blog-index.scss'
import '../styles/blog-template.scss'
import '../styles/about.scss'
import '../styles/archive.scss'
import '../styles/404.scss'

import Footer from '../components/Footer';
import Header from '../components/Header';


const Layout = ({ children }) => (

    <React.Fragment>
      <Header/>
      <SEO />
      {children()}
      <Footer/>
    </React.Fragment>

);

Layout.propTypes = {
  children: PropTypes.func.isRequired,
};

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx